import { SalesforceProductPrice } from '~/lib/salesforce/types';

export type ProductEventData = {
    brand: string;
    category: string;
    category2?: string;
    category3?: string;
    category4?: string;
    category5?: string;
    color: string;
    ean: string;
    freightGroup: string;
    fullfillment: string;
    id: string;
    name: string;
    /** Absent outside list contexts - a product page has no position in a list. */
    position?: number;
    ratingCount: number;
    ratingValue: number;
    price: number;
    quantity: number;
    queryId?: string;
    rating: string;
    serie: string;
    variant: string;
    c_prices?: SalesforceProductPrice[];
    cust_prices?: SalesforceProductPrice[];
    coupon?: string;
    stockStatus?: boolean;
};

// GA promotion_type. Both kinds share the view_promotion/select_promotion events, so this tells
// them apart. A sponsored placement is a boosted product hit, not a record in the Algolia index.
export const PROMOTION_EVENT_TYPE = {
    PROMOTIONAL_CONTENT: 'promotional_content',
    SPONSORED_PLACEMENT: 'sponsored_placement',
} as const;

export type PromotionEventType = (typeof PROMOTION_EVENT_TYPE)[keyof typeof PROMOTION_EVENT_TYPE];

export type PromotionEventData = {
    id: string;
    name?: string;
    title?: string;
    ctaText?: string;
    category?: string;
    position?: number;
    type: typeof PROMOTION_EVENT_TYPE.PROMOTIONAL_CONTENT;
};

export type SponsoredPromotionEventData = {
    type: typeof PROMOTION_EVENT_TYPE.SPONSORED_PLACEMENT;
    // sp_<category-slug>_<ean>
    id: string;
    creativeName: string;
    creativeSlot: string;
    itemListId: string;
    itemListName: string;
    product: ProductEventData;
};

export type PromotionEvent = PromotionEventData | SponsoredPromotionEventData;

export type WishListEventData = {
    eventAction: string;
    eventLabel?: string;
    productId: string;
    brand?: string;
    name?: string;
};
